/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsTopActionableIssuesFilter extends models.AppSecopsDashboardRequestBase {
    getFixupPrototypeFunction() { return AppSecopsTopActionableIssuesFilter.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsTopActionableIssuesFilter>): AppSecopsTopActionableIssuesFilter {
        let obj = Object.assign(new AppSecopsTopActionableIssuesFilter(), model);
        AppSecopsTopActionableIssuesFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsTopActionableIssuesFilter>): AppSecopsTopActionableIssuesFilter {
        if (!model) return null;
        return AppSecopsTopActionableIssuesFilter.newInstance(<AppSecopsTopActionableIssuesFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsTopActionableIssuesFilter) {
        if (!obj) return;

        models.AppSecopsTopActionableIssuesFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsTopActionableIssuesFilter): boolean {
        if (models.AppSecopsDashboardRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsTopActionableIssuesFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Security category
     */
    categories: Array<models.SecurityCategory>;

    /**
     * Query based on Tenant ID, Application ID, Portfolio ID, Project ID and SBOM references
     */
    filters: models.QueryOperator;

    /**
     * If not set, grouping is defaulted to Project. This can either be set to application or unique vulnerability.
     */
    view_by: models.AppInsightsViewBy;

    /**
     * Search text to filter the actionable issues based on CVE ID
     */
    search: string;

    /**
     * Time range bucket for grouping vulnerabilities based on NVD published date or SBOM created date
     */
    days_range: models.DaysRange;

    /**
     * True if all versions are required to be considered; false considers only the latest version of SBOMs
     */
    all_version: boolean;

}
